export default "__VITE_ASSET__BVIBX4iv__"